/**
 * Percoro Design System — Color Constants
 * Single source of truth for all brand colors.
 * Tickets #215 + #289
 *
 * Import: import { COLORS } from '../utils/colors';
 */

export const COLORS = {
  // ── Brand Primary (Transformative Teal) ──
  primary:      '#2D6E6A',
  primaryLight: '#4A8F8A',
  primaryDark:  '#1F4E4A',

  // ── Backgrounds ──
  paper:        '#FAF8F3', // Cloud Dancer
  white:        '#FFFFFF',

  // ── Text ──
  ink:          '#1A2826', // primary text
  inkMuted:     '#4A5E5C', // secondary text

  // ── Category Accents (trip item types) ──
  categoryFlight:      '#2D6E6A', // teal
  categoryHotel:       '#4A6FA5', // slate blue
  categoryHotelDark:   '#3D5A8A',
  categoryCar:         '#7A8C6E', // sage green
  categoryActivity:    '#2D6E6A', // teal
  categoryRestaurant:  '#8B4513', // burnt sienna
  categoryTour:        '#8B4513', // burnt sienna
  categoryDestination: '#6B4C7A', // heritage plum
  categoryCommunity:   '#C17B3E', // amber

  // ── Tonal Pastels (icon backgrounds) ──
  pastelTeal:   '#C8DDD8',
  pastelCoral:  '#F0E0D0',
  pastelBlue:   '#D0D8E8',
  pastelPlum:   '#D8D0E8',
  pastelSand:   '#EDE0C8',
  pastelSky:    '#C8DCE8',

  // ── Semantic ──
  success:  '#4CAF50',
  warning:  '#FFB347',
  error:    '#FF6B6B',
  info:     '#4A6FA5',
} as const;

export type ColorKey = keyof typeof COLORS;
